import React from 'react';

const PrivacyPolicy = () => {
	return (
		<div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#0f0c29] via-[#302b63] to-[#24243e] text-white px-4">
			<section className="max-w-[1000px] w-full my-24 px-6 sm:px-10 py-16 rounded-2xl bg-white/10 border border-white/20 shadow-[0_8px_30px_rgba(0,0,0,0.5)] backdrop-blur">
				<h1 className="text-4xl sm:text-5xl font-extrabold mb-8 text-center bg-gradient-to-r from-yellow-400 via-blue-600 to-purple-600 bg-clip-text text-transparent drop-shadow">
					Privacy Policy
				</h1>

				<p className="text-center text-white/90 text-base sm:text-lg mb-10">
					MASRIQ NextTech Solutions is committed to protecting your privacy. This policy explains how we handle your information for all our stakeholders.
				</p>

				<div className="space-y-10">
					<div>
						<h2 className="text-2xl font-bold mb-3 text-blue-400">1. Privacy Policy for Users/Clients</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>We collect and process personal information (name, email, phone, company details) to provide quotations, deliver services, and support your experience.</li>
							<li>Data is stored securely and only used for service delivery, support, and legal compliance.</li>
							<li>We do not sell or share your data with third parties except as required by law.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-purple-400">2. Privacy Policy for Investors</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>Investor information (name, contact, financial details) is handled with strict confidentiality.</li>
							<li>Data is used solely for investment management, reporting, and regulatory compliance.</li>
							<li>We maintain robust security measures and do not disclose investor data without explicit consent or legal requirement.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-green-400">3. Privacy Policy for Partners</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>Partner data (business contacts, agreements, communications) is used to manage collaborations, joint projects, and business development.</li>
							<li>We protect partner information and only share it as necessary for partnership activities or legal obligations.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-pink-400">4. Privacy Policy for Students/Interns</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>We collect intern/student data (name, contact, educational background) for recruitment, onboarding, and program management.</li>
							<li>Data is kept confidential and used only for internship administration and legal compliance.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-red-400">5. Privacy Policy for Employees</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>Employee data (personal, payroll, performance) is collected for HR, payroll, and legal purposes.</li>
							<li>We ensure employee privacy and only share data with authorized personnel or as required by law.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-yellow-300">General Rights</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>
								All individuals may request access, correction, or deletion of their data by contacting{' '}
								<a className="text-blue-200 underline" href="mailto:info@masriq.tech">info@masriq.tech</a>.
							</li>
							<li>We comply with applicable data protection laws and strive to maintain the highest standards of privacy.</li>
						</ul>
					</div>
				</div>

				<p className="mt-10 text-center text-white/90">
					For questions or concerns, please contact us at{' '}
					<a className="text-blue-200 underline" href="mailto:info@masriq.tech">info@masriq.tech</a>.
				</p>
			</section>
		</div>
	);
};

export default PrivacyPolicy;
